/* global axios */
import ApiClient from './ApiClient';

export const buildTaskParams = (page, status, assignee, sort, search) => {
  let params = `page=${page}`;
  if (status) {
    params = `${params}&status=${status}`;
  }
  if (assignee) {
    params = `${params}&assignee=${assignee}`;
  }
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  if (search) {
    params = `${params}&q=${encodeURIComponent(search)}`;
  }
  return params;
};

class TaskAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    const {
      page = 1,
      status = '',
      assignee = '',
      sort = '',
      search = '',
    } = params;
    const requestURL = `${this.url}?${buildTaskParams(page, status, assignee, sort, search)}`;
    return axios.get(requestURL);
  }

  search({ q = '', limit = 5 }) {
    return axios.get(
      `${this.url}/search?q=${encodeURIComponent(q)}&limit=${limit}`
    );
  }

  myTasks() {
    return axios.get(`${this.url}/my_tasks`);
  }

  stats() {
    return axios.get(`${this.url}/stats`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(taskData) {
    return axios.post(this.url, { task: taskData });
  }

  update(id, taskData) {
    return axios.patch(`${this.url}/${id}`, { task: taskData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }
}

export default new TaskAPI();
